import { atom } from 'jotai';
import { ITransactionDataModel } from '../../../data-models/transaction.data-model';
import { IFinanceRoundDataModel } from '../../../data-models/finance-round.data-model';

export type TFinanceAction =
  | 'addTransaction'
  | 'editTransaction'
  | 'assignToInvestment'
  | 'deleteTransaction'
  | 'editInvestment'
  | 'deleteInvestment'
  | 'linkAumni';

export const showModalStateFinance = atom<TFinanceAction | null>(null);

export const selectedTransactionStateFinance = atom<ITransactionDataModel | null>(null);

export const selectedInvestmentStateFinance = atom<IFinanceRoundDataModel | null>(null);
